import {StyleSheet} from 'react-native';
import {Colors} from '../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: 500,
    alignSelf: 'center',
    height: 500,
    backgroundColor: 'white',
    borderRadius: 8,
    paddingHorizontal: 30,
    paddingVertical: 30,
    justifyContent: 'center',
  },
  imageBackground: {flex: 1, paddingHorizontal: 15, justifyContent: 'center', backgroundColor: '#e61c2b'},
  simbol: {alignSelf: 'center', marginBottom: 70},
  title: {
    fontSize: 22,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 26,
    textAlign: 'center',
    color: 'black',
    maxWidth: 200,
    alignSelf: 'center',
  },
  description: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    color: 'gray',
    textAlign: 'center',
    maxWidth: 350,
    alignSelf: 'center',
    marginTop: 20,
  },
  goBack: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    textAlign: 'center',
    maxWidth: 220,
    alignSelf: 'center',
    marginTop: 20,
    color: Colors.RedPallete.red,
  },
});
